import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Dropdown from "../input/Dropdown";
import Button from "../input/Button";
import { GoArrowSwitch } from "react-icons/go";
import { userActions } from "../../store/user/user-slice";
import { localStorageKeys } from "../../const";
import { updateUserCompany } from "../../api/authApi";

const UserCompany = ({ closeModal }) => {
  const company = useSelector((state) => state.user.company);
  const user = useSelector((state) => state.user.username);
  const currentCompanyId = useSelector((state) => state.user.currentCompany);
  const [companyList, setCompanyList] = useState([]);
  const [currentCompany, setCurrentCompany] = useState(
    currentCompanyId !== null ? parseInt(currentCompanyId) : -1,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    setCompanyList(
      (company ?? []).map((item) => ({
        key: item.comId,
        text: item.comCompany,
        value: item.comId,
      })),
    );
    setCurrentCompany(
      currentCompanyId !== null ? parseInt(currentCompanyId) : -1,
    );
  }, [company, currentCompanyId]);

  return (
    <form className="ui form" style={{ overflowY: "auto", height: "250px" }}>
      <div className="ui segment" style={{ height: "100%" }}>
        <h4 className="ui dividing header">User Company</h4>
        <div className="field">
          <Dropdown
            required={true}
            clearable={false}
            label="Company"
            placeholder="Company"
            options={companyList}
            value={currentCompany}
            style={{ height: "20px" }}
            onChange={(e, data) => {
              setCurrentCompany(data.value);
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "flex-end",
            gap: "5px",
            marginTop: "70px",
          }}
        >
          <Button
            label="Switch"
            Icon={GoArrowSwitch}
            onClick={async (e) => {
              const company = await updateUserCompany({
                user,
                company: currentCompany,
              });
              dispatch(userActions.setUserCompany(company));
              localStorage.setItem(
                localStorageKeys.USER.CURRENT_COMPANY,
                company.toString(),
              );
              closeModal();
            }}
            disabled={currentCompanyId === currentCompany}
          />
        </div>
      </div>
    </form>
  );
};

export default UserCompany;
